/**
 *  tomcat 部署 图片名称不能使用中文
 */

// 用户列表
const user_list = [
    {
        id: 1,
        name: "七月",
        online: true,
        type: "",
        avatar:"",
        role:'master'
    },
    {
        id: 1,
        name: "初音",
        online: true,
        type: "",
        avatar: require("@/assets/login_images/newlogo.png"),
        role:'manager'
    },
    {
        id: 2,
        name: "雪",
        online: false,
        type: "",
        avatar: require("@/assets/login_images/newlogo.png"),
        role:'manager'
    },
    {
        id: 3,
        name: "可可罗",
        online: false,
        type: "",
        avatar: require("@/assets/login_images/newlogo.png"),
    },
    {
        id: 4,
        name: "栞",
        online: false,
        type: "",
        avatar: require("@/assets/login_images/newlogo.png"),
    },
];

// 公告列表
const notice_list = [
    {
        id: 1,
        type: "文件",
        title: "RocketMQ原理.dock",
    },
    {
        id: 2,
        type: "公告",
        title: "RocketMQ原理",
    },
]

// 历史记录
const history = [
    {
        username: "历史记录",
        avatar: require("@/assets/login_images/newlogo.png"),
        toid: 1,
        type: "group",
        content: "audio[https://www.w3school.com.cn/i/horse.mp3]",
        cid: 0,
        mine: false,
        fromid: 3,
        timestamp: new Date(),
    },
];

//  测试发送数据
const test_send_msg = [
    {
        username: "小白",
        avatar: require("@/assets/login_images/newlogo.png"),
        id: 1,
        type: "group",
        content: "img[/emoticon/emoticon_1.jpg]",
        cid: 0,
        mine: false,
        fromid: 2,
        timestamp: new Date(),
    },
    {
        username: "小奶",
        avatar: require("@/assets/login_images/newlogo.png"),
        id: 1,
        type: "group",
        content: "video[https://www.w3school.com.cn/i/movie.mp4]",
        cid: 0,
        mine: false,
        fromid: 3,
        timestamp: new Date(),
    },
    {
        username: "老八",
        avatar: require("@/assets/login_images/newlogo.png"),
        id: 1,
        type: "group",
        content: "audio[https://www.w3school.com.cn/i/horse.mp3]",
        cid: 0,
        mine: false,
        fromid: 3,
        timestamp: new Date(),
    },
]

const mine = {
    // 昵称
    username: "客服",
    // 用户id
    id: "1",
    //状态
    status: "online",
    //签名
    sign: "为您服务",
    avatar: require("@/assets/leftNav/default_avatar.png"),
}

const chats = [
    {
        id: -1,
        name: "系统消息",
        type: "sys_msg",
        online: false,
        avatar: require("@/assets/leftNav/system_avatar.png"),
    }
]

export default {
    notice_list,
    user_list,
    history,
    test_send_msg,
    mine,
    chats
}